import React from "react";

/**
 * GridBackground
 * A small, reusable grid background component for React + Tailwind CSS.
 *
 * Props:
 * - children: React nodes rendered on top of the grid
 * - className: additional classes for container
 * - size: grid cell size in pixels (number)
 * - stroke: CSS color for grid lines (string)
 * - strokeWidth: width of the grid lines in px (number)
 * - opacity: opacity of the grid lines (0-1)
 *
 * Usage (example):
 * <GridBackground size={16} stroke="rgba(0,0,0,0.06)">...
 *   Your content
 * </GridBackground>
 */

export default function GridBackground({
  children,
  className = "",
  size = 20,
  stroke,
  strokeWidth = 1,
  opacity = 1,
}) {
  return (
    <div className={`relative w-full overflow-hidden ${className}`}>
      {/* Grid background with CSS variables for theme support */}
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `
            linear-gradient(to right, var(--bd-50) ${strokeWidth}px, transparent ${strokeWidth}px),
            linear-gradient(to bottom, var(--bd-50) ${strokeWidth}px, transparent ${strokeWidth}px)
          `,
          backgroundSize: `${size}px ${size}px`,
          opacity: stroke ? opacity : 0.3,
        }}
      />
      {/* Content overlay */}
      <div className="relative z-10">{children}</div>
    </div>
  );
}
